/**
 * Removes old user-specific storage keys, keeping only the current user's key
 */
export const cleanupUserSpecificStorageKeys = (currentKey: string, baseKey: string) => {
    try {
        const prefix = `${baseKey}_`;
        const keysToRemove: string[] = [];

        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.startsWith(prefix) && key !== currentKey) {
                keysToRemove.push(key);
            }
        }

        keysToRemove.forEach((key) => localStorage.removeItem(key));
        localStorage.removeItem(baseKey);
    } catch {
        // Silently fail if localStorage is unavailable
    }
};
